import * as React from 'react'
import Button from '../button/button'
import './cookie-consent.scss'

class CookieConsent extends React.Component<{}, any> {
  constructor() {
    super()

    this.state = {
      consent: this.getCookie('consent'),
    }
  }

  public getCookie = (name: string) => {
    const nameEQ = name + '='
    if (typeof window !== 'undefined') {
      const ca = window.document.cookie.split(';')

      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length)
        }
        if (c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length, c.length)
        }
      }
    }
    return null
  }
  public onConsent = () => {
    if (typeof window !== 'undefined') {
      window.document.cookie = `consent=true; path=/`
    }
    this.setState({ consent: true })
  }

  public render() {
    if (!!this.state.consent) {
      return null
    }
    return (
      <div className="cookie-consent">
        <div className="notice">
          We use cookies to help us offer you the best online experience. By
          continuing to use our website and/or clicking OK, you're agreeing to
          our use of cookies in accordance with our cookies policy.{' '}
          <a href="/cookies">Learn More</a>
        </div>
        <Button
          href="javascript:void(0)"
          onClick={this.onConsent}
          content="OK"
        />
      </div>
    )
  }
}

export default CookieConsent



// WEBPACK FOOTER //
// ./src/components/cookie-consent/cookie-consent.tsx